export default {
  CAMPAIGNS_FETCHED: 'CAMPAIGNS_FETCHED',
  CAMPAIGNS_LOAD: 'CAMPAIGNS_LOAD',
  CUPOM_OFFERS_ESTABLISHMENT_LOAD: 'CUPOM_OFFERS_ESTABLISHMENT_LOAD',
  CUPOM_OFFERS_ESTABLISHMENT_FETCHED: 'CUPOM_OFFERS_ESTABLISHMENT_FETCHED',
  BASIC_GRAPHS_FETCHED: 'BASIC_GRAPHS_FETCHED',
  BASIC_GRAPH_LOAD: 'BASIC_GRAPH_LOAD',
  BASIC_GRAPH_DETAIL: 'BASIC_GRAPH_DETAIL',
};
